import { Injectable } from '@angular/core';

import { ApiService, ChaptersService, GlobalVar } from 'src/app/services';
import { Chapter } from 'src/app/models/chapters';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookService {
  public books: Array<any> = [];
  public systemTypes = [
    { title: "Belemmerend", type: 0, bookName: '', hasBookName: false, newChapterTitle: '' },
    { title: "Bezielend", type: 1, bookName: '', hasBookName: false, newChapterTitle: '' },
  ];

  constructor(
    public globalvar: GlobalVar,
    public apiService: ApiService,
  ) { }

  post(body) {
    body.user_id = this.globalvar._user.id;
    return this.apiService.post(this.globalvar._createBook, body);
  }

  put(id, body) {
    return this.apiService.post(`${this.globalvar._putBook}/${id}`, body);
  }

  get() {

  }

  getAll() {
    return this.apiService.get(`${this.globalvar._getBooks}/${this.globalvar._user.id}`);
  }

  async setData() {
    const data: any = await this.getAll();

    this.books = [];
    this.systemTypes.forEach((systemType: any) => {
      systemType.id = null;
      systemType.bookName = '';
      systemType.hasBookName = false;
    });

    if (!Array.isArray(data)) {
      return false;
    }

    data.forEach(book => {
      this.systemTypes.forEach((systemType: any) => {
        if (book.system_type === systemType.type) {
          systemType.id = book.id;
          systemType.bookName = book.name;
          systemType.hasBookName = true;
          this.books[book.system_type] = book;
        }
      });
    });

    return true;
  }

  resetSystemTypesValues() {
    this.systemTypes.forEach(e => {
      e.newChapterTitle = '';
      e.bookName = '';
      e.hasBookName = false;
    });
  }
}
